export default __webpack_public_path__ + "static/media/google-play-badge.f9d36b27.svg";